<template>
  <div>
    CompetitionDetailSubjectLayout
  </div>
</template>

<script>
export default {
  name: "CompetitionDetailSubjectLayout"
}
</script>

<style scoped>

</style>